module.exports = __webpack_public_path__ + "img/jnr_settings.bbd929da.png";